import React from 'react';
import { Container } from './ui/Container';
export function JourneyTimelineSection() {
  return <section className="py-16 bg-blue-50" data-id="element-230">
      <Container data-id="element-231">
        <div className="text-center mb-12" data-id="element-232">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-233">
            Your Path to Quiet Sleep
          </h2>
        </div>

        <div className="relative max-w-4xl mx-auto" data-id="element-234">
          {/* Vertical Line */}
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-1 bg-blue-200 transform md:-translate-x-1/2" data-id="element-235"></div>

          {[{
          week: 'Week 1',
          title: 'Noticeable Reduction',
          desc: 'Snoring volume decreases significantly. Partner sleeps better.'
        }, {
          week: 'Week 2',
          title: 'Deeper Rest',
          desc: 'You start waking up feeling more refreshed and energetic.'
        }, {
          week: 'Week 3',
          title: 'Relationship Improving',
          desc: 'Snoring is nearly eliminated. Tension in the relationship fades.'
        }, {
          week: 'Week 4',
          title: 'Total Transformation',
          desc: 'Sleeping together peacefully. Energy and mood fully restored.'
        }].map((step, index) => <div key={index} className={`relative flex items-center mb-12 ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`} data-id="element-236">
              {/* Dot */}
              <div className="absolute left-4 md:left-1/2 w-8 h-8 bg-blue-600 rounded-full border-4 border-white shadow-lg transform -translate-x-1/2 z-10 flex items-center justify-center" data-id="element-237">
                <div className="w-2 h-2 bg-white rounded-full" data-id="element-238"></div>
              </div>

              {/* Content */}
              <div className={`ml-12 md:ml-0 w-full md:w-1/2 ${index % 2 === 0 ? 'md:pr-12 md:text-right' : 'md:pl-12 md:text-left'}`} data-id="element-239">
                <div className="bg-white p-6 rounded-xl shadow-md border border-blue-100" data-id="element-240">
                  <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800 text-xs font-bold rounded-full mb-2" data-id="element-241">
                    {step.week}
                  </span>
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-242">
                    {step.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-243">{step.desc}</p>
                </div>
              </div>
            </div>)}
        </div>
      </Container>
    </section>;
}